import { memo } from 'react';
import Styles from '../styles.module.scss';

import withComponentName from '../../../../../decorators/withComponentName';

import shieldImg from '../../../../../assets/homepage/pic-shield.svg';

const DataSecurity = () => (
  <section className={Styles['data-security-section']}>
    <div className={Styles['data-security-text']}>
      <h1 className={`${Styles.title} text-uppercase`}>Your data under your control</h1>
      <p className={Styles.institutions}>
        Are you concerned with how much data companies and websites gather
        indiscriminately and store indefinitely,
        then use to generate significant revenue at the cost of your privacy?
      </p>
      <div className={Styles['data-security-text-block']}>
        <span
          className={`${Styles.institutions} d-inline`}
        >
          To spread our advocacy of privacy, we adhere to a
        </span>
        {' '}
        <a href="/privacy">strict privacy policy</a>
        .
        {' '}
        <span className={`${Styles.institutions}`}>
          It’s your data, and we
          guard yours just like we guard ours - with utmost care. The data we do collect is
          {' '}
        </span>
        <a href="https://help.cityfalcon.com/hc/en-us/articles/360002405258" target="_blank" rel="noopener noreferrer">used judiciously</a>
        <span className={`${Styles.institutions}`}>, solely to improve your experience.</span>
      </div>
      <p className={Styles.institutions}>
        We will never sell your data, and you are free to
        {' '}
        <a href="/hc/en-us/articles/360034218434-Requesting-your-data">request what we’ve collected</a>
        {' '}
        from you at any time (registered users only).
      </p>
    </div>
    <div>
      <img src={shieldImg} alt="" />
    </div>
  </section>
);

export default withComponentName(memo(DataSecurity));
